import React, { useState, useEffect } from "react";
import { Input, Button, Form } from "antd";
import { gqlBuilderWhere, helperFunc } from "common/utils";
import FlooringForms from "../../forms";
import Icons from "components/icons";
import { DrawerStandart, Localize } from "components/service";
import { IFilter } from "../../helpers/flooring-variation-types-helper";

const { Search } = Input;

interface IFilterList
{
  [ key: string ]: IFilter;
}

interface IFlooringVariationTableFilterProps
{
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  setFilters: React.Dispatch<React.SetStateAction<IFilter | undefined>>;
  setResetSorting: React.Dispatch<React.SetStateAction<{ column: string; order: "ASC" | "DESC" }[] | undefined>>;
  flooringVariationFilters: IFilterList | undefined;
  filters: IFilter | undefined;
  objOrderBy: { column: string; order: "ASC" | "DESC" }[];
  filtersStorageKey: string;
  sortingStorageKey: string;
}

const FlooringVariationTableFilter: React.FC<IFlooringVariationTableFilterProps> = ({
  setFilters = () => { },
  setResetSorting = () => { },
  flooringVariationFilters,
  filters,
  setSearchText,
  objOrderBy,
  filtersStorageKey,
  sortingStorageKey,
}) =>
{
  const [ form ] = Form.useForm();
  const [ filterList, setFilterList ] = useState<IFilterList | undefined>(undefined);
  const [ count, setCount ] = useState<any>({});

  const filterCount = helperFunc.countFilterList(count);

  useEffect(() =>
  {
    if (filters) {
      localStorage.setItem(
        filtersStorageKey,
        JSON.stringify(filterList ?? flooringVariationFilters ?? {})
      );
    } else {
      form.resetFields([
        "ORGANIZER_ID",
        "MIN_PRICE",
        "MAX_PRICE",
        "MIN_PRICE_BASIC",
        "MAX_PRICE_BASIC",
      ]);
    }
  }, [ filters ]);

  useEffect(() =>
  {
    if (flooringVariationFilters) {
      setFilters(gqlBuilderWhere(flooringVariationFilters));
    }

    setCount({
      ...flooringVariationFilters,
    });
  }, []);

  const resetFilters = () =>
  {
    setCount({});
    setFilterList({});
    setFilters(gqlBuilderWhere({}));
    setResetSorting(objOrderBy);
    localStorage.removeItem(filtersStorageKey);
    localStorage.removeItem(sortingStorageKey);
  };

  return (
    <>
      <Search
        className="filter-search"
        prefix={<Icons.Search />}
        onChange={(e) => setSearchText(e.target.value)}
      />

      <Form
        key="flooring-variation-filters-form"
        className="clear-css-prop table-filter-form"
        layout="vertical"
        form={form}
      >
        <DrawerStandart
          extraClass={"modal-form filters"}
          modalButton={
            <Button icon={<Icons.Filter />}>
              <span className="ellipsis">
                <Localize>FORMS.Button_Text_Filters</Localize>
              </span>
              {!!filterCount && (
                <span className="filter-count">{filterCount}</span>
              )}
            </Button>
          }
        >
          <strong className="modal-title">
            <span className="text">
              <Localize>FORMS.Title_Text_Filters</Localize>
            </span>
          </strong>

          <FlooringForms.VariationFilter
            setCount={setCount}
            setFilters={setFilters}
            setFilterList={setFilterList}
            setResetSorting={setResetSorting}
            filterList={filterList}
            flooringVariationFilters={flooringVariationFilters}
            filtersStorageKey={filtersStorageKey}
            sortingStorageKey={sortingStorageKey}
            objOrderBy={objOrderBy}
            gqlBuilderWhere={gqlBuilderWhere}
            form={form}
            action={() => { }}
          />
        </DrawerStandart>

        {filters && (
          <Button
            className="underline"
            onClick={resetFilters}
          >
            <span>
              <Localize>FORMS.Button_Text_Reset</Localize>
            </span>
          </Button>
        )}
      </Form>
    </>
  );
};

export default FlooringVariationTableFilter;
